<template>
  <div dir="rtl">
    <div class="row">
      <div class="f23-l30-b df36-l39-b">{{data.title}}</div>
    </div>
    <div class="row bottom-separator dpadding-tb-20 dpadding-rl-0 dmargin-top-50">
      <span class="col-10">
        <a class="black-link f14-l19 df20-l20" :href="data.service.href">{{data.service.text}}</a>
      </span>
      <span class="col-2 text-left">
        <a :href="data.service.mail.href"><img class="quicklink-arrow" src="@/assets/icons/red-left-arrow.svg"></a>
      </span>
    </div>
    <div class="row bottom-separator dpadding-tb-20 dpadding-rl-0">
      <span class="col-10">
        <a class="black-link f14-l19 df20-l20" :href="data.faq.href">{{data.faq.text}}</a>
      </span>
      <span class="col-2 text-left">
        <a :href="data.faq.href"><img class="quicklink-arrow" src="@/assets/icons/red-left-arrow.svg"></a>
      </span>
    </div>
    <div class="row dpadding-tb-20 dpadding-rl-0">
      <span class="col-10">
        <a class="black-link f14-l19 df20-l20" :href="data.become_a_chef.href">{{data.become_a_chef.text}}</a>
      </span>
      <span class="col-2 text-left">
        <a :href="data.become_a_chef.href"><img class="quicklink-arrow" src="@/assets/icons/red-left-arrow.svg"></a>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Object
  },
}
</script>